import { initApp } from './js/core/app.js'

require('./scss/main.scss')
require('../node_modules/swiper/swiper-bundle.css')

document.addEventListener('DOMContentLoaded', initApp)
